import {getPsrs} from '../../services/Api';
import {generateFiservAliancaPsrs, generateStoneTonPsrs} from '../../services/psrAlianca';
import {generateiFoodPsr} from '../../services/iFoodPsr';
import {
  getStringWithPsrAcceptedByCnae,
  psrDefineGroupTypes,
  sendMessageGetFirstPsrTypeSelected
} from '../../services/psr';
import {ErrorWarning} from '../../shared/components/ErrorWarning';
import {useChatStore} from '../../store/slices/chatStore';
import {useInteractionStore} from '../../store/slices/interactionStore';
import {usePsrStore} from '../../store/slices/psrStore';
import {startScrollingChat} from '../../utils';

export const PsrReplay = () => {
  const productsCnae = useInteractionStore((state) => state.productsCnae);
  const psrPaymentType = usePsrStore((state) => state.psrPaymentType);
  const setPsrsGroupShow = usePsrStore((state) => state.setPsrsGroupShow);
  const setPsrGroupType = usePsrStore((state) => state.setPsrGroupType);
  const setDotTyping = useInteractionStore((state) => state.setDotTyping);
  const sendMessage = useChatStore((state) => state.sendMessage);
  const responseTypeChange = useChatStore((state) => state.responseTypeChange);

  const getPSrsRequest = () => {
    const productsGroup = getStringWithPsrAcceptedByCnae(productsCnae);

    getPsrs(productsGroup).then((res) => {
      let newResponseData = generateiFoodPsr(res.data);
      newResponseData = generateFiservAliancaPsrs(newResponseData);
      newResponseData = generateStoneTonPsrs(newResponseData);
      setPsrsGroupShow(newResponseData);

      const psrsGroupTypes = psrDefineGroupTypes(newResponseData);
      setPsrGroupType(psrsGroupTypes);

      const nextMessage = sendMessageGetFirstPsrTypeSelected(
        psrPaymentType.physical
      );
      sendMessage(nextMessage);
      responseTypeChange('disabled');
      setDotTyping(false);
    });

    startScrollingChat(0);
  };

  return (
    <div className="warning-content">
      <ErrorWarning htmlId="repeat-request-psrs" request={getPSrsRequest} />
    </div>
  );
};
